<template>
  <div>
    <!-- 上传组件 -->
    <a-upload
      :customRequest="handleRequest"
      :show-upload-list="false"
      :multiple="true"
      @change="handleChange"
    >
      <a-button>
        <upload-outlined></upload-outlined>
        上传文件
      </a-button>
    </a-upload>

    <!-- 图片列表 -->
    <div class="image-list">
      <div v-for="(url, index) in fileList" :key="url" class="image-item">
        <a-image
          :src="ToImage(url)"
          alt="Uploaded Image"
          class="uploaded-image"
          :width="170"
        />
        <a-button
          type="primary"
          danger
          @click="removeImage(index)"
          class="delete-button"
        >
          删除
        </a-button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { UploadOutlined } from "@ant-design/icons-vue";
import { FileService } from "@/api/services/FileService";
import { message } from "ant-design-vue";
import { UploadRequestOption } from "ant-design-vue/lib/vc-upload/interface";
import { ref, watch } from "vue";
import { ToImage } from "@/utils/image";

const props = defineProps<{
  modelValue: Array<string>;
}>();

const emit = defineEmits<{
  (e: "update:modelValue", value: Array<string>): void;
}>();

const fileList = ref<Array<string>>(props.modelValue || []);

// 处理文件上传
const handleRequest = async (option: UploadRequestOption) => {
  const res = await FileService.Upload({ file: option.file as Blob });
  if (res.code === 0) {
    message.success("上传成功");
    fileList.value.push(res.data);
    emit("update:modelValue", fileList.value);
  } else {
    message.error(res.msg);
  }
};

// 处理上传状态变化
const handleChange = (info: any) => {
  if (info.file.status === "done") {
    message.success(`${info.file.name} 上传成功`);
  } else if (info.file.status === "error") {
    message.error(`${info.file.name} 上传失败`);
  }
};

// 删除图片
const removeImage = (index: number) => {
  fileList.value.splice(index, 1);
  emit("update:modelValue", fileList.value);
};

// 监听 modelValue 的变化
watch(
  () => props.modelValue,
  (newVal) => {
    fileList.value = newVal;
  },
  { immediate: true }
);
</script>

<style scoped>
.image-list {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 10px;
}

.image-item {
  position: relative;
  display: inline-block;
}

.uploaded-image {
  height: 100px; /* 设置固定高度 */
  width: auto; /* 宽度自适应 */
  display: block;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  margin-top: 10px;
}

.delete-button {
  position: absolute;
  top: 5px;
  right: 5px;
  background-color: #ff4d4f;
  color: white;
  border: none;
  padding: 5px 10px;
  cursor: pointer;
  font-size: 12px;
}
</style>
